<script>
import constants from '../common/constants';
import { VueRecaptcha } from "vue-recaptcha";
import axios from "axios";
import qs from "qs";
import { Validator } from 'simple-vue3-validator'
import store from '../../store'

export default {
    components: {
        VueRecaptcha
    },
    
    data() {
        return {
            minPasswordLength: 9,
            recaptchaVerified: false,
            userEmail: "",
            userPassword: "",
            serverMessage: "",
            tempUserFeedback: "",
            linkAccountMode: false,
            accountAccessToken: null,
            userEmailChecked: false,
            userProvider: "",
            isPasswordSetupRequired: false,
            showProviderForm: false
        };
    },

    watch: {
        userEmail: function() {
            this.serverMessage = "";
            this.tempUserFeedback = "";
        },
        userPassword: function() {
            this.serverMessage = "";
            this.tempUserFeedback = "";
        }
    },

    methods: {
        async submitGfLoginAccount() {
            var vm = this;
            var success = this.$validate();
            if (success) {
                if (
                    vm.captchaPublicKey != "" &&
                    !vm.recaptchaVerified &&
                    !vm.demo
                ) {
                    this.executeRecaptcha();
                } else {
                    vm.makeLogonRequest();
                }
            }
        },

        RecaptchaAsVerified(token) {
            this.recaptchaVerified = true;
            this.makeLogonRequest(token);
        },

        async postLogon(captchaResult) {
            var vm = this;
            return axios
                .post("/account/logon", vm.constructFormData(captchaResult), {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
        },

        executeRecaptcha() {
            var vm = this;
            vm.$refs.invisibleRecaptcha.execute();
        },

        resetRecaptcha() {
            var vm = this;
            if(vm.captchaPublicKey != "")
                vm.$refs.invisibleRecaptcha.reset();
        },

        emitEvent(eventName, params) {
            var vm = this;
            vm.$emit(eventName, params);
        },

        async makeLogonRequest(captchaResult) {
            var vm = this;
            this.resetRecaptcha();

            if (
                this.linkAccountMode &&
                this.accountAccessToken &&
                this.accountAccessToken.length > 0
            )
                return this.linkAccount();

            try {
                var accountLogonResponse = await vm.postLogon(captchaResult);
                vm.$gfLogger.logInfo('LoginAccountInitializer.vue makeLogonRequest /account/logon, accountLogonResponse:', accountLogonResponse);
                if (accountLogonResponse.data.Success) {
                    vm.userProvider = accountLogonResponse.data.DefaultProvider;
                    vm.showProviderForm = true;
                    vm.isInitialSetup = true
                    vm.$gfLogger.logInfo(`LoginAccountInitializer accountLogonResponse.data.Success`, accountLogonResponse)
                    return;
                }
                if (accountLogonResponse.data.TempData === undefined) {
                    vm.emitEvent('loggedIn', vm.userEmail);
                    if (accountLogonResponse.data.redirectUrl)
                        return vm.redirectToPage(accountLogonResponse.data.redirectUrl);
                    else
                        return vm.redirectToPage(vm.returnUrl);
                }
                return vm.processServerResponse(accountLogonResponse.data);
            }
            catch (err) {
                vm.$gfLogger.logInfo('LoginAccountInitializer.vue makeLogonRequest, err:', err);
                if (err !== undefined && err.response !== undefined && err.response.status !== undefined && err.response.status == 302) {
                    vm.redirectToPage(vm.returnUrl);
                    return;
                }
            }
        },
        async submitEmailAddress() {
            var vm = this;
            var success = await this.$validate();

            if (success) {
                vm.$gfLogger.logInfo('LoginAccountInitializer.vue submitEmailAddress success, vm.userEmail:', vm.userEmail);
                await vm.getUserLoginProvider(vm.userEmail);
            }
        },

        async executeGetUserLoginProvider(userEmail) {
            return axios
                .post("/account/get-user-login-provider?emailAddress=" + encodeURIComponent(userEmail), null,
                    {
                        headers: {
                            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
                            "x-requested-with": "XMLHttpRequest"
                        }
                    })
        },

        async getUserLoginProvider(userEmail) {
            var vm = this;
            vm.$gfLogger.logInfo('getUserLoginProvider, userEmail:', userEmail);
            try {
                var loginProviderResult = await vm.executeGetUserLoginProvider(userEmail);
                vm.$gfLogger.logInfo('get-user-login-provider success', loginProviderResult);
                store.commit('setUserEmail', userEmail)
                vm.userEmailChecked = true;
                vm.isPasswordSetupRequired = loginProviderResult.data.IsPasswordSetupRequired;
                vm.userProvider = loginProviderResult.data.DefaultProvider.toLowerCase() == constants.PROVIDER_GOFUNDRAISE.toLowerCase()
                    ? ''
                    : loginProviderResult.data.DefaultProvider;
                vm.showProviderForm = loginProviderResult.data.DefaultProvider.toLowerCase() == constants.PROVIDER_GOFUNDRAISE.toLowerCase()
                    ? false
                    : true;
            }
            catch (err) {
                vm.$gfLogger.logInfo('get-user-login-provider failed', err);
            }
        },

        linkAccount() {
            var vm = this;
            this.$gfLogger.logInfo(
                `Linking account using access token ${this.accountAccessToken}`
            );
            axios({
                method: "post",
                url: "/account/link-account-facebook",
                data: qs.stringify({
                    ReturnUrl: "",
                    Provider: "facebook",
                    Data: this.accountAccessToken,
                    InFrame: this.inframe,
                    UserName: this.userEmail,
                    Password: this.userPassword
                }),
                headers: {
                    "content-type":
                        "application/x-www-form-urlencoded;charset=utf-8",
                    "x-requested-with": "XMLHttpRequest"
                }
            }).then(function(data) {
                vm.$gfLogger.logInfo("Link account response:", data);
                if (data.data && data.data.success === true) {
                    vm.$gfLogger.logInfo("Successfully linked account");
                    vm.emitEvent('loggedIn');
                    vm.redirectToPage(vm.returnUrl);
                } else {
                    vm.serverMessage =
                        "The username / password specified is not valid. Please confirm details and try again.";
                }
            });
        },

        constructFormData(captchaResult) {
            var vm = this;
            return {
                TuringTest: captchaResult,
                ReturnUrl: vm.returnUrl,
                InFrame: vm.inframe,
                UserName: vm.userEmail,
                Password: vm.userPassword,
                Data: ""
            };
        },

        redirectToPage(url) {
          if (this.disableRedirect)
            return

            window.location.replace(url);
        },

        processServerResponse(data) {
            if (
                data.TempData["Status.Css"] &&
                data.TempData["Status.Css"].toLowerCase() == "error"
            ) {
                this.serverMessage = data.TempData["Status.Message"];
                this.recaptchaVerified = false;
            }
        }
    },
    validators: {
        userEmail: function(userEmail) {
            return Validator.value(userEmail)
                .required()
                .email();
        },
        userPassword: function(userPassword) {
            if (this.userEmailChecked)
                return Validator.value(userPassword).required();
        }
    }
};
</script>
